<template>
  <div>
    <loader v-if="isLoading"/>
    <router-view v-else/>
  </div>
</template>

<script>
import loader from "@/components/layout/animations/loader";

export default {
  name: 'App',
  components: { loader },
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
